import React from 'react';

import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Unit } from '../../../app/models/Unit';
import UnitForm from '../../Units/components/forms/UnitForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    unit: Unit;
    setUnit: (unit: Unit) => void;
    errorFields?: any;
}

const UnitFormContainer = ({
    fetching,
    action,
    cancel,
    unit,
    setUnit,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <UnitForm
                        unitDataForm={unit}
                        setUnitDataForm={setUnit}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default UnitFormContainer;
